import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AppMenuService, TopLevelMenuComponent } from '@cumlaude/shared-components-menu';
import { AuthService } from '@cumlaude/shared-authentication';
import { AsyncPipe } from '@angular/common';
import { map } from 'rxjs/operators';
import { EnvConfiguration, ENV_CONFIG, getFriendlyEnvironmentName } from '@cumlaude/shared-configuration';
import { VERSION } from '@cumlaude/version-generator';
import { IconComponent } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-admin-header',
	templateUrl: './admin-header.component.html',
	styleUrls: ['./admin-header.component.scss'],
	imports: [TopLevelMenuComponent, AsyncPipe, IconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminHeaderComponent {
	readonly envConfig: EnvConfiguration = inject(ENV_CONFIG);
	authService = inject(AuthService);
	menuService = inject(AppMenuService);

	environmentName = getFriendlyEnvironmentName(this.envConfig.environmentName);

	version = VERSION;

	account$ = this.authService.sub$.pipe(map((sub) => sub.replace(/\w\//, '')));
}
